import { useState, useEffect, useCallback } from 'react';
import { Bold, Flex } from './TremorCompat';
import { Panel, Slider, Text } from 'rsuite';

import { DisplayIcon } from './DisplayIcon';
import { devLog } from '../utils/devLog';

const markLinkStyle = {
  fontSize: 10,
  fontWeight: 500,
  padding: '2px',
};

export const DisplaySensorOffsetSliderItem = ({
  register,
  tc,
  icon,
  min,
  max,
  step,
  onChange,
  disabled,
  borderOff,
}) => {
  const convertToSliderValue = useCallback(
    (theValue) => {
      return Number.isFinite(theValue) ? (theValue - 15) / 2 : min;
    },
    [min],
  );

  const [value, setValue] = useState(() => convertToSliderValue(register.value));

  const forMatValue = () => {
    return value + '°C';
  };

  const convertFromSliderValue = (sValue) => {
    return sValue * 2 + 15;
  };

  const updateValue = (value, event) => {
    const convertedValue = convertFromSliderValue(value);
    devLog('converted from slider =', convertedValue, event, value);
    onChange(register, convertedValue);
  };

  useEffect(() => {
    const convertedValue = convertToSliderValue(register.value);
    setValue(convertedValue);
    devLog('temperature value updated to :', convertedValue);
  }, [register.value, convertToSliderValue]);

  return (
    <Panel bordered={!borderOff} style={{ backgroundColor: 'white' }}>
      <Flex justifyContent="start" className="space-x-4">
        <DisplayIcon icon={icon} />
        <div className="truncate space-y-1 w-1/2">
          <Text color={tc} className="truncate">
            {register.title}
          </Text>
          <Text color={tc} className="truncate">
            <Bold>{value}°C</Bold>
          </Text>
        </div>
        <div
          style={{
            display: 'block',
            width: '100%',
            paddingLeft: 10,
            paddingRight: 5,
          }}
        >
          <Slider
            progress
            barClassName="slideritem"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={setValue}
            onChangeCommitted={updateValue}
            renderTooltip={forMatValue}
            disabled={disabled}
            graduated
            renderMark={(mark) => {
              if ([-5, -4, -3, -2, -1, 0, 1, 2, 3, 4, 5].includes(mark)) {
                return <span style={markLinkStyle}>{mark}°C</span>;
              }
              return null;
            }}
          />
        </div>
      </Flex>
    </Panel>
  );
};
